module.exports = __webpack_public_path__ + "static/media/roomcloud.5c7a620a.png";